export const page = {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    alignItems: 'center'
}